import $ from 'static/script/libs/jquery'
module.exports = $.ajax;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/ajax.js